import { getActivePinia, type StoreGeneric } from "pinia";

/**
 * Disposes a store that belongs to one page, state included, so the page's next visit starts from
 * the store's initial state.
 *
 * `$dispose()` alone stops the store's effects but leaves its state in `pinia.state`, and the next
 * `useXStore()` is built from that state: the previous visit's deal would render until the new load
 * answered. Deleting the entry is Pinia's documented way to drop it.
 *
 * Call it from `onBeforeUnmount`: `onUnmounted` runs after the component that replaces this one has
 * set up, so it would dispose the store the replacement just picked up, as a keyed remount does.
 */
export function disposePageStore(store: StoreGeneric): void {
  store.$dispose();
  const pinia = getActivePinia();
  if (pinia !== undefined) delete pinia.state.value[store.$id];
}
